import { UserRequest } from './user-request';

export class VerificationRequest extends UserRequest {
    public code: string;
}
